import React from 'react';
import './Button.css';

const OutlineButton = ({
  onClick,
  children,
  size = 'medium',
  disabled = false,
  className = '',
  type = 'button',
}) => {
  const sizeClass = size === 'large' ? 'btn-large' : size === 'small' ? 'btn-small' : '';
  return (
    <button
      type={type}
      className={`btn btn-outline ${sizeClass} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default OutlineButton;
